import React, { Component } from "react";
import StimService from "../StimService";
import {
  TextField,
  Button,
  Typography,
  Box,
  CircularProgress,
  Snackbar,
  Modal,
  Grid,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import { Alert } from "@mui/material";
import { withRouter } from "react-router-dom";
import { Autocomplete } from "@mui/material";
import Preview from "./Preview";
import HttpService from "../../Dashboard/duck/HttpService";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

export class EditStim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      stimName: "",
      adtype: "",
      adAssetTypeId: "",
      adTypeGroupId: "",
      brand: "",
      availableAdTypes: [],
      availableAdAssetTypes: [],
      availableAdTypeGroups: [],
      availableBrands: [],
      isLoading: true,
      error: null,
      successMessage: null,
      source: null,
      stimtype: "",
      tag: "",
      errors: { name: false, adtype: false, brand: false },
      newBrandName: "",
      newBrandCategory: "",
      newBrandModalOpen: false,
      isSuperUser: false,
      successModalOpen: false,
      errorModalOpen: false,
      snackbarOpen: false,
      snackbarMessage: "",
      snackbarSeverity: "success",
      snackbarShouldRedirect: false,

      advancedModalOpen: false,

      width: "",
      height: "",
      file_size: "",
      video_time: "",

      video_looped: true,
      video_autoplay: true,
      video_mute: false,
      video_showcontrols: false,
      video_fullscreen: false,
      video_play_inview: false,
      video_dynamic_width_percent: 1,
      advancedSaving: false,

      availableLanguages: [],
      availableLocations: [],
      languageId: "",
      countryId: "",
      clutter: false,
      activeTab: 0,
      fullscreenPreviewOpen: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    const superUser = localStorage.getItem("superUser");
    this.setState({ isSuperUser: superUser === "true" });

    Promise.all([
      StimService.getStim(id),
      StimService.getAdTypes(),
      StimService.getBrands(),
      StimService.getAdAssetTypes(),
      HttpService.getLanguageList(),
      HttpService.getLocationsList(),
    ])
      .then(
        ([
          stimResponse,
          adTypesResponse,
          brandsResponse,
          adAssetTypesResponse,
          languageResponse,
          locationResponse,
        ]) => {
          console.log("stimResponse.data", stimResponse.data);

          const {
            name,
            ad_type_id,
            brand_id,
            source,
            stim_type,
            tag,
            ad_asset_type_id,
            ad_group_type_id,
            width,
            height,
            file_size,
            video_time,

            video_looped,
            video_autoplay,
            video_mute,
            video_showcontrols,
            video_fullscreen,
            video_play_inview,
            video_dynamic_width_percent,

            clutter,
            language_id,
            country_id,
          } = stimResponse.data;

          this.setState(
            {
              id,
              stimName: name,
              adtype: ad_type_id,
              brand: brand_id,
              availableAdTypes: adTypesResponse.data,
              availableBrands: brandsResponse.data,
              availableAdAssetTypes: adAssetTypesResponse.data,
              adAssetTypeId: ad_asset_type_id || "",
              adTypeGroupId: ad_group_type_id || "",
              source,
              stimtype: stim_type,
              tag,
              width: width ?? "",
              height: height ?? "",
              file_size: file_size ?? "",
              video_time: video_time ?? "",

              video_looped: video_looped ?? true,
              video_autoplay: video_autoplay ?? true,
              video_mute: video_mute ?? false,
              video_showcontrols: video_showcontrols ?? false,
              video_fullscreen: video_fullscreen ?? false,
              video_play_inview: video_play_inview ?? false,
              video_dynamic_width_percent: video_dynamic_width_percent ?? 1,
              availableLanguages: languageResponse.data,
              availableLocations: locationResponse.data,
              languageId: language_id || "",
              countryId: country_id || "",
              clutter: !!clutter,
              isLoading: false,
            },
            () => {
              if (ad_asset_type_id) {
                this.fetchAdTypeGroups(ad_asset_type_id);
              }
            }
          );
        }
      )
      .catch((error) => {
        this.setState({
          isLoading: false,
          snackbarOpen: true,
          snackbarMessage:
            "Error fetching stimulus details or dropdown options",
          snackbarSeverity: "error",
        });
      });
  }

    getBackPath = () => {
    const locationState = this.props.location?.state || {};

    if (
      locationState.fromStudySpecificStimSelector &&
      locationState.returnTo
    ) {
      return locationState.returnTo;
    }

    return "/stims";
  };

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : value;

    this.setState({ [name]: finalValue });

    if (name === "adAssetTypeId") {
      this.setState({ adTypeGroupId: "", adtype: "" });
      this.fetchAdTypeGroups(value);
    }

    if (name === "adTypeGroupId") {
      this.setState({ adtype: "" });
      this.fetchAdTypes(value);
    }
  };

  fetchAdTypeGroups = (adAssetTypeId) => {
    StimService.getAdTypeGroups(adAssetTypeId)
      .then((response) => {
        const availableAdTypeGroups = response.data;

        const { adTypeGroupId } = this.state;

        const validAdTypeGroupId = availableAdTypeGroups.find(
          (group) => group.id === adTypeGroupId
        )
          ? adTypeGroupId
          : null;

        this.setState({
          availableAdTypeGroups,
          adTypeGroupId: validAdTypeGroupId,
        });
      })
      .catch((error) => {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: "Failed to load ad type groups",
          snackbarSeverity: "error",
        });
      });
  };

  fetchAdTypes = (adTypeGroupId, callback = () => {}) => {
    StimService.getAdTypes(adTypeGroupId)
      .then((response) => {
        const availableAdTypes = response.data;

        this.setState({
          availableAdTypes,
        });

        callback();
      })
      .catch((error) => {
        this.setState({
          snackbarOpen: true,
          snackbarMessage: "Failed to load ad types",
          snackbarSeverity: "error",
        });
      });
  };

  handleModalOpen = async () => {
    try {
      const response = await StimService.getBrandCategories();
      this.setState({
        newBrandModalOpen: true,
        categories: response.data,
        errors: { name: "", category: "", stimName: "" },
      });
    } catch (error) {
      this.setState({
        errors: { ...this.state.errors, category: "Failed to load categories" },
      });
    }
  };

  handleCreateBrand = async () => {
    const { newBrandName, newBrandCategory } = this.state;
    let formIsValid = true;
    const newErrors = { brandName: "", category: "" };

    if (!newBrandName) {
      newErrors.brandName = "Brand Name is required";
      formIsValid = false;
    }

    if (!newBrandCategory) {
      newErrors.category = "Select a brand Category";
      formIsValid = false;
    }

    if (!formIsValid) {
      this.setState({ errors: newErrors });
      return;
    }

    try {
      await StimService.createBrand(
        newBrandName,
        newBrandName.toLowerCase(),
        newBrandCategory.id
      );

      const res = await StimService.getBrands();
      const updatedBrands = res.data;

      const matchedBrand = updatedBrands.find((b) => b.name === newBrandName);

      this.setState({
        availableBrands: updatedBrands,
        brand: matchedBrand ? matchedBrand.id : "",
        newBrandModalOpen: false,
        newBrandName: "",
        newBrandCategory: "",
        errors: { brandName: "", category: "" },
      });

      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Brand created successfully!",
        snackbarSeverity: "success",
        snackbarShouldRedirect: false,
      });
    } catch (error) {
      this.setState({
        snackbarOpen: true,
        snackbarMessage: "Failed to create brand.",
        snackbarSeverity: "error",
      });
    }
  };

  handleSnackbarClose = () => {
    this.setState(
      {
        snackbarOpen: false,
      },
      () => {
        if (this.state.snackbarShouldRedirect) {
          const backPath = this.getBackPath();

          this.setState({ snackbarShouldRedirect: false }, () => {
            this.props.history.push(backPath);
          });
        }
      }
    );
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      id,
      stimName,
      adtype,
      adAssetTypeId,
      adTypeGroupId,
      brand,
      video_looped,
      video_autoplay,
      video_mute,
      video_showcontrols,
      video_fullscreen,
      video_play_inview,
      video_dynamic_width_percent,
      languageId,
      countryId,
      clutter,
    } = this.state;

    let errors = {};

    if (!stimName) {
      errors.stimName = "Stim Name is required";
    }

    if (!adAssetTypeId) {
      errors.adAssetTypeId = "Ad Asset Type is required";
    }

    if (!adTypeGroupId) {
      errors.adTypeGroupId = "Ad Type Group is required";
    }

    if (!adtype) {
      errors.adtype = "Ad Type is required";
    }

    if (!brand) {
      errors.brand = "Brand is required";
    }
    if (!languageId) {
      errors.languageId = "Language is required";
    }

    if (!countryId) {
      errors.countryId = "Location is required";
    }

    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    try {
      const response = await StimService.editStim(id, {
        name: stimName,
        ad_type_id: adtype,
        ad_asset_type_id: adAssetTypeId,
        ad_group_type_id: adTypeGroupId,
        brand_id: brand,
        video_looped,
        video_autoplay,
        video_mute,
        video_showcontrols,
        video_fullscreen,
        video_play_inview,
        video_dynamic_width_percent,
        language_id: Number(languageId),
        country_id: Number(countryId),
        clutter,
      });

      if (response?.data?.success === false) {
        throw new Error(
          response?.data?.message ||
            response?.data?.error ||
            "Error updating stimulus."
        );
      }
    this.setState({
      snackbarOpen: true,
      snackbarMessage: "Stimulus updated successfully!",
      snackbarSeverity: "success",
      snackbarShouldRedirect: true,
    });
    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.detail ||
        error?.message ||
        "Error updating stimulus. Please try again later.";

      this.setState({
        snackbarOpen: true,
        snackbarMessage: backendMessage,
        snackbarSeverity: "error",
      });
    }
  };

handleAdvancedSettingsSave = async () => {
  const {
    id,
    stimName,
    adtype,
    adAssetTypeId,
    adTypeGroupId,
    brand,
    source,
    video_looped,
    video_autoplay,
    video_mute,
    video_showcontrols,
    video_fullscreen,
    video_play_inview,
    video_dynamic_width_percent,
    languageId,
    countryId,
    clutter,
  } = this.state;

  this.setState({ advancedSaving: true });

  try {
    const response = await StimService.editStim(id, {
      name: stimName,
      ad_type_id: adtype,
      ad_asset_type_id: adAssetTypeId,
      ad_group_type_id: adTypeGroupId,
      brand_id: brand,
      source,

      video_looped,
      video_autoplay,
      video_mute,
      video_showcontrols,
      video_fullscreen,
      video_play_inview,
      video_dynamic_width_percent,

      language_id: Number(languageId),
      country_id: Number(countryId),
      clutter,
    });

    if (response?.data?.success === false) {
      throw new Error(
        response?.data?.message ||
          response?.data?.error ||
          "Failed to save advanced settings."
      );
    }

    this.setState({
      advancedSaving: false,
      advancedModalOpen: false,
      snackbarOpen: true,
      snackbarMessage: "Advanced settings saved successfully!",
      snackbarSeverity: "success",
      snackbarShouldRedirect: false,
    });
  } catch (error) {
    const backendMessage =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.response?.data?.detail ||
      error?.message ||
      "Failed to save advanced settings.";

    this.setState({
      advancedSaving: false,
      snackbarOpen: true,
      snackbarMessage: backendMessage,
      snackbarSeverity: "error",
    });
  }
};

  handleExit = () => {
    this.props.history.push(this.getBackPath());
  };

handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  openFullscreenPreview = () => {
  this.setState({ fullscreenPreviewOpen: true });
};

closeFullscreenPreview = () => {
  this.setState({ fullscreenPreviewOpen: false });
};

renderStimPreview = (isFullscreen = false) => {
  const { source, stimtype, tag } = this.state;

  const mediaStyle = {
    width: "100%",
    height: "100%",
    objectFit: isFullscreen ? "contain" : "cover",
    display: "block",
    backgroundColor: "#000",
  };

  if (stimtype === "v" || stimtype === "i") {
    if (source && source.match(/\.(mp4|webm|ogg)$/i)) {
      return (
        <video controls controlsList="nofullscreen" style={mediaStyle}>
          <source src={source} type="video/mp4" />
        </video>
      );
    }

    return <img src={source} alt="Stimulus preview" style={mediaStyle} />;
  }

  return (
    <Preview selectedType={stimtype} tag={tag} scriptData={tag} vastUrl={tag} />
  );
};

  render() {
    const {
      isSuperUser,
      stimName,
      adtype,
      adAssetTypeId,
      adTypeGroupId,
      brand,
      availableAdTypes,
      availableAdAssetTypes,
      availableAdTypeGroups,
      availableBrands,
      isLoading,
      source,
      stimtype,
      tag,
      newBrandModalOpen,
      newBrandName,
      newBrandCategory,
      errors,

      advancedModalOpen,
      width,
      height,
      file_size,
      video_time,
      video_looped,
      video_autoplay,
      video_mute,
      video_showcontrols,
      video_fullscreen,
      video_play_inview,
      video_dynamic_width_percent,
      advancedSaving,
      availableLanguages,
      availableLocations,
      languageId,
      countryId,
      clutter,
      activeTab,

    } = this.state;

    if (isLoading) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
        </Box>
      );
    }

return (
  <div
    style={{
      width: "100%",
      minHeight: "90vh",
      padding: "40px",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        position: "absolute",
        top: "100px",
        left: "100px",
        zIndex: 5,
      }}
    >
      <Tooltip title="Back to table">
        <IconButton onClick={this.handleExit} aria-label="back" size="large">
          <ArrowBackRoundedIcon />
        </IconButton>
      </Tooltip>
    </div>

    <Box
      sx={{
        maxWidth: "1100px",
        margin: "0 auto",
        mt: 1,
      }}
    >
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography
          component={"span"}
          variant="h4"
          style={{
            textAlign: "center",
            marginBottom: "10px",
            color: "#00badb",
          }}
        >
          EDIT STIM
        </Typography>
      </Box>

      <Paper
        elevation={1}
        style={{ marginBottom: 24, position: "sticky", top: 0, zIndex: 10 }}
      >
        <Tabs
          value={activeTab}
          onChange={this.handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          centered
          variant="fullWidth"
        >
          <Tab label="Edit Stim Details" />
          <Tab label="Preview" />
        </Tabs>
      </Paper>

      <Snackbar
        open={this.state.snackbarOpen}
        autoHideDuration={20000}
        onClose={this.handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={this.handleSnackbarClose}
          severity={this.state.snackbarSeverity}
          variant="outlined"
          action={
            <Button
              color="inherit"
              size="small"
              onClick={this.handleSnackbarClose}
            >
              OK
            </Button>
          }
        >
          {this.state.snackbarMessage}
        </Alert>
      </Snackbar>

      <Modal
        open={this.state.errorModalOpen}
        onClose={() => this.setState({ errorModalOpen: false })}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "8px",
            width: "400px",
            textAlign: "center",
          }}
        >
          <Typography variant="h6" gutterBottom component={"span"}>
            Error
          </Typography>
          <Typography component={"span"} color="error">
            {this.state.error}
          </Typography>
          <Button
            onClick={() => this.setState({ errorModalOpen: false })}
            variant="contained"
            color="secondary"
            style={{ marginTop: "20px" }}
          >
            Close
          </Button>
        </div>
      </Modal>

      {activeTab === 0 && (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "28px 32px",
            borderRadius: "12px",
            maxWidth: "980px",
            margin: "0 auto",
          }}
        >
          <Box display="flex" justifyContent="center">
            <form
              onSubmit={this.handleSubmit}
              style={{ width: "100%", maxWidth: "920px" }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                  columnGap: "24px",
                  rowGap: "4px",
                  alignItems: "start",
                }}
              >
                <Box>
                  <Box sx={{ mb: "16px" }}>
                    <TextField
                      name="stimName"
                      label="Stim Name *"
                      value={stimName}
                      onChange={this.handleInputChange}
                      variant="outlined"
                      fullWidth
                      error={!!errors.stimName}
                      helperText={errors.stimName ? "Required" : " "}
                      FormHelperTextProps={{
                        sx: {
                          minHeight: "20px",
                          lineHeight: "1.2em",
                        },
                      }}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: "4px",
                      }}
                    />
                  </Box>

                  <Box sx={{ mb: "16px" }}>
                    <Autocomplete
                      options={availableAdAssetTypes}
                      getOptionLabel={(option) => option?.name ?? ""}
                      value={
                        availableAdAssetTypes.find(
                          (t) => String(t.id) === String(adAssetTypeId)
                        ) || null
                      }
                      onChange={(e, newValue) => {
                        this.handleInputChange({
                          target: {
                            name: "adAssetTypeId",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ad Asset Type *"
                          variant="outlined"
                          fullWidth
                          error={!!errors.adAssetTypeId}
                          helperText={errors.adAssetTypeId ? "Required" : " "}
                          FormHelperTextProps={{
                            sx: { minHeight: "20px", lineHeight: "1.2em" },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-input": {
                              backgroundColor: "transparent !important",
                              boxShadow: "none !important",
                            },
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    />
                  </Box>


                  <Box sx={{ mb: "16px" }}>
                    <Autocomplete
                      options={availableAdTypes}
                      getOptionLabel={(option) => option?.name ?? ""}
                      value={
                        availableAdTypes.find(
                          (t) => String(t.id) === String(adtype)
                        ) || null
                      }
                      onChange={(e, newValue) => {
                        this.handleInputChange({
                          target: {
                            name: "adtype",
                            value: newValue ? newValue.id : "",
                          },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ad Type *"
                          variant="outlined"
                          fullWidth
                          error={!!errors.adtype}
                          helperText={errors.adtype ? "Required" : " "}
                          FormHelperTextProps={{
                            sx: { minHeight: "20px", lineHeight: "1.2em" },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-input": {
                              backgroundColor: "transparent !important",
                              boxShadow: "none !important",
                            },
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    />
                  </Box>
                </Box>

                <Box>
                  <Box sx={{ mb: "16px" }}>
                    <Autocomplete
                      options={availableBrands}
                      getOptionLabel={(option) => option?.name ?? ""}
                      isOptionEqualToValue={(option, value) =>
                        String(option?.id) === String(value?.id)
                      }
                      value={
                        availableBrands.find((b) => String(b.id) === String(brand)) || null
                      }
                      onChange={(e, newValue) => {
                        this.setState({ brand: newValue ? newValue.id : "" });
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          key={option?.id ?? `${option?.name}-${option?.value ?? ""}`}
                        >
                          {option?.name ?? ""}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Brand *"
                          variant="outlined"
                          fullWidth
                          error={!!errors.brand}
                          helperText={errors.brand ? "Required" : " "}
                          FormHelperTextProps={{
                            sx: { minHeight: "20px", lineHeight: "1.2em" },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-input": {
                              backgroundColor: "transparent !important",
                              boxShadow: "none !important",
                            },
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    />
                  </Box>

                  <Box sx={{ mb: "16px" }}>
                    <Autocomplete
                      options={availableAdTypeGroups}
                      getOptionLabel={(option) => option?.name ?? ""}
                      value={
                        availableAdTypeGroups.find(
                          (g) => String(g.id) === String(adTypeGroupId)
                        ) || null
                      }
                      onChange={(e, newValue) => {
                        this.handleInputChange({
                          target: {
                            name: "adTypeGroupId",
                            value: newValue ? newValue.id : "",
                          },
                        });

                        this.handleInputChange({
                          target: { name: "adtype", value: "" },
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Ad Type Group *"
                          variant="outlined"
                          fullWidth
                          error={!!errors.adTypeGroupId}
                          helperText={errors.adTypeGroupId ? "Required" : " "}
                          FormHelperTextProps={{
                            sx: { minHeight: "20px", lineHeight: "1.2em" },
                          }}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "transparent",
                              boxShadow: "none",
                            },
                            "& .MuiOutlinedInput-input": {
                              backgroundColor: "transparent !important",
                              boxShadow: "none !important",
                            },
                            borderRadius: "4px",
                          }}
                        />
                      )}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                      columnGap: "24px",
                      alignItems: "start",
                    }}
                  >
                    <Box sx={{ mb: "16px" }}>
                      <Autocomplete
                        options={availableLocations}
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          String(option?.id) === String(value?.id)
                        }
                        value={
                          availableLocations.find(
                            (location) => String(location.id) === String(countryId)
                          ) || null
                        }
                        onChange={(e, newValue) => {
                          this.setState({ countryId: newValue ? newValue.id : "" });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Location *"
                            variant="outlined"
                            fullWidth
                            error={!!errors.countryId}
                            helperText={errors.countryId ? "Required" : " "}
                            FormHelperTextProps={{
                              sx: { minHeight: "20px", lineHeight: "1.2em" },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                              },
                              "& .MuiOutlinedInput-input": {
                                backgroundColor: "transparent !important",
                                boxShadow: "none !important",
                              },
                              borderRadius: "4px",
                            }}
                          />
                        )}
                      />
                    </Box>

                    <Box sx={{ mb: "16px" }}>
                      <Autocomplete
                        options={availableLanguages}
                        getOptionLabel={(option) => option?.name ?? ""}
                        isOptionEqualToValue={(option, value) =>
                          String(option?.id) === String(value?.id)
                        }
                        value={
                          availableLanguages.find(
                            (lang) => String(lang.id) === String(languageId)
                          ) || null
                        }
                        onChange={(e, newValue) => {
                          this.setState({ languageId: newValue ? newValue.id : "" });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Language *"
                            variant="outlined"
                            fullWidth
                            error={!!errors.languageId}
                            helperText={errors.languageId ? "Required" : " "}
                            FormHelperTextProps={{
                              sx: { minHeight: "20px", lineHeight: "1.2em" },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                              },
                              "& .MuiOutlinedInput-input": {
                                backgroundColor: "transparent !important",
                                boxShadow: "none !important",
                              },
                              borderRadius: "4px",
                            }}
                          />
                        )}
                      />
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      mb: "16px",
                      minHeight: "56px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={!!clutter}
                          onChange={this.handleInputChange}
                          name="clutter"
                        />
                      }
                      label="Clutter"
                    />
                  </Box>
                </Box>
              </Box>

              {isSuperUser && (
                <Box display="flex" justifyContent="center" mt={0}>
                  <Typography
                    component={"span"}
                    onClick={this.handleModalOpen}
                    style={{
                      color: "#00badb",
                      textDecoration: "underline",
                      cursor: "pointer",
                      marginTop: "10px",
                      textAlign: "center",
                    }}
                  >
                    Create new brand
                  </Typography>
                </Box>
              )}

              <Box display="flex" justifyContent="center" gap={2} mt={2}>
                {stimtype === "v" && (
                  <Button
                    type="button"
                    variant="outlined"
                    onClick={() => this.setState({ advancedModalOpen: true })}
                  >
                    Advanced Settings
                  </Button>
                )}

                <Button type="submit" className="button-primary">
                  Save Changes
                </Button>
              </Box>
            </form>
          </Box>
        </div>
      )}

      {activeTab === 1 && (
        <div
          style={{
            backgroundColor: "#fff",
            padding: "24px",
            borderRadius: "12px",
            maxWidth: "1000px",
            margin: "0 auto",
          }}
        >
          <Typography
            component={"span"}
            variant="h6"
            style={{ marginBottom: "12px", display: "block" }}
          >
          </Typography>

           <div
              style={{
                padding: "12px",
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#fafafa",
                height: "58vh",
                maxWidth: "760px",
                margin: "0 auto",
                overflow: "hidden",
                position: "relative",
              }}
            >
                <style>
                  {`
                    video::-webkit-media-controls-fullscreen-button {
                      display: none !important;
                    }
                  `}
                </style>

            <Tooltip title="Expand preview">
              <div
                onClick={() => {
                  if (source || tag) {
                    this.openFullscreenPreview();
                  }
                }}
                style={{
                  position: "absolute",
                  top: "17px",
                  right: "18px",
                  zIndex: 30,
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: !source && !tag ? "not-allowed" : "pointer",
                  opacity: !source && !tag ? 0.4 : 1,
                }}
              >
                <span
                  style={{
                    color: "#fff",
                    fontSize: "26px",
                    fontWeight: "bold",
                    lineHeight: 1,
                  }}
                >
                  ⛶
                </span>
              </div>
            </Tooltip>

              {this.renderStimPreview(false)}
            </div>
        </div>
      )}

      <Modal
        open={this.state.fullscreenPreviewOpen}
        onClose={this.closeFullscreenPreview}
      >
        <div
          style={{
            width: "100vw",
            height: "100vh",
            backgroundColor: "#000",
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "48px",
            boxSizing: "border-box",
          }}
        >
          <IconButton
            onClick={this.closeFullscreenPreview}
            style={{
              position: "absolute",
              top: "20px",
              right: "24px",
              color: "#fff",
              zIndex: 20,
              backgroundColor: "rgba(0,0,0,0.45)",
            }}
          >
            X
          </IconButton>

          <div
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "1400px",
              maxHeight: "900px",
              overflow: "hidden",
            }}
          >
            {this.renderStimPreview(true)}
          </div>
        </div>
      </Modal>

      <Modal
        open={advancedModalOpen}
        onClose={() => this.setState({ advancedModalOpen: false })}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "32px",
            borderRadius: "12px",
            width: "100%",
            maxWidth: "900px",
            maxHeight: "85vh",
            overflowY: "auto",
            position: "relative",
          }}
        >
          <Typography
            component={"span"}
            onClick={() => this.setState({ advancedModalOpen: false })}
            style={{
              position: "absolute",
              top: "14px",
              right: "18px",
              cursor: "pointer",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            X
          </Typography>

          <Box width="100%" maxWidth={900} mx="auto">
            <Typography
              variant="h5"
              gutterBottom
              align="center"
              style={{ color: "#00badb" }}
            >
              Advanced Settings
            </Typography>

            <Typography
              variant="subtitle2"
              color="textSecondary"
              align="center"
              gutterBottom
              style={{ marginBottom: "24px" }}
            >
              Video advanced settings
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Width"
                  value={width}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Height"
                  value={height}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Size of the file"
                  value={file_size}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label="Video time"
                  value={video_time}
                  fullWidth
                  variant="outlined"
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_looped}
                      onChange={this.handleInputChange}
                      name="video_looped"
                    />
                  }
                  label="Video Looped"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_autoplay}
                      onChange={this.handleInputChange}
                      name="video_autoplay"
                    />
                  }
                  label="Video Autoplay"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_mute}
                      onChange={this.handleInputChange}
                      name="video_mute"
                    />
                  }
                  label="Video Mute"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_showcontrols}
                      onChange={this.handleInputChange}
                      name="video_showcontrols"
                    />
                  }
                  label="Video Show Controls"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_fullscreen}
                      onChange={this.handleInputChange}
                      name="video_fullscreen"
                    />
                  }
                  label="Video Fullscreen"
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!video_play_inview}
                      onChange={this.handleInputChange}
                      name="video_play_inview"
                    />
                  }
                  label="Video Play Inview"
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="video_dynamic_width_percent"
                  label="Video Dynamic Width Percent"
                  value={video_dynamic_width_percent}
                  onChange={this.handleInputChange}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="center" mt={4}>
              <Button
                variant="contained"
                onClick={this.handleAdvancedSettingsSave}
                disabled={advancedSaving}
                style={{
                  backgroundColor: "#00badb",
                  color: "#fff",
                }}
              >
                {advancedSaving ? "Saving..." : "Save Advanced Settings"}
              </Button>
            </Box>
          </Box>
        </div>
      </Modal>

      <Modal
        open={newBrandModalOpen}
        onClose={() => this.setState({ newBrandModalOpen: false })}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            backgroundColor: "#fff",
            padding: "30px",
            borderRadius: "8px",
            width: "400px",
            position: "relative",
          }}
        >
          <Typography
            component={"span"}
            onClick={() => this.setState({ newBrandModalOpen: false })}
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              cursor: "pointer",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            X
          </Typography>

          <Typography
            component={"span"}
            variant="h6"
            style={{ marginBottom: "20px" }}
          >
            Create New Brand
          </Typography>

          <TextField
            label="Brand Name *"
            value={newBrandName}
            onChange={(e) => this.setState({ newBrandName: e.target.value })}
            variant="outlined"
            fullWidth
            style={{
              marginBottom: "20px",
              backgroundColor: "#fff",
              borderRadius: "4px",
            }}
            error={this.state.errors.name !== ""}
            helperText={this.state.errors.name}
            FormHelperTextProps={{ style: { minHeight: "20px" } }}
          />

          <Autocomplete
            value={newBrandCategory}
            onChange={(e, newValue) =>
              this.setState({ newBrandCategory: newValue })
            }
            options={this.state.categories || []}
            getOptionLabel={(option) => option.name || ""}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Brand Category *"
                variant="outlined"
                fullWidth
                style={{
                  marginBottom: "20px",
                  backgroundColor: "#fff",
                  borderRadius: "4px",
                }}
                error={this.state.errors.category !== ""}
                helperText={this.state.errors.category}
                FormHelperTextProps={{ style: { minHeight: "20px" } }}
              />
            )}
          />

          <Button
            onClick={this.handleCreateBrand}
            variant="contained"
            style={{
              backgroundColor: "#00badb",
              color: "#fff",
              width: "100%",
              marginTop: "20px",
            }}
          >
            Create Brand
          </Button>
        </div>
      </Modal>
    </Box>
  </div>
);
  }
}

export default withRouter(EditStim);